import { render, staticRenderFns } from "./PromptpayId.vue?vue&type=template&id=5b4dc8da&scoped=true"
import script from "./PromptpayId.vue?vue&type=script&lang=js"
export * from "./PromptpayId.vue?vue&type=script&lang=js"
import style0 from "./PromptpayId.vue?vue&type=style&index=0&id=5b4dc8da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4dc8da",
  null
  
)

export default component.exports